import { render, staticRenderFns } from "./CommandeForm.vue?vue&type=template&id=873a79f8"
import script from "./CommandeForm.vue?vue&type=script&lang=js"
export * from "./CommandeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports